import {
  GET_PERSONALIZATION_PENDING,
  GET_PERSONALIZATION_FAILED,
  GET_PERSONALIZATION_FULFILLED,
} from "constants-lib/actionTypes"
import { API_STATUSES } from "constants-lib/common"

const initialState = {
  fetchStatus: ``,
  statusCode: ``,
  requestTrackingId: ``,
  errorMsg: {},
  data: {},
}

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case GET_PERSONALIZATION_FULFILLED:
      return {
        ...state,
        fetchStatus: API_STATUSES.FULFILLED,
        statusCode: action.payload.statusCode,
        requestTrackingId: action.payload.requestTrackingId,
        errorMsg: action.payload.errorMsg,
        data: action.payload.data,
      }

    case GET_PERSONALIZATION_PENDING:
      return {
        ...state,
        fetchStatus: API_STATUSES.PENDING,
      }

    case GET_PERSONALIZATION_FAILED:
      return {
        ...state,
        fetchStatus: API_STATUSES.FAILED,
      }
    default:
      return state
  }
}
